import React from "react";
import "./CTA.css";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const CTA = () => {
  const { t } = useTranslation();

  const particlesInit = async (main) => {
    await loadFull(main);
  };

  return (
    <section className="cta-wrapper">
      <Particles
        id="cta-particles"
        init={particlesInit}
        options={{
          fullScreen: false,
          background: { color: { value: "transparent" } },
          particles: {
            number: { value: 20 },
            color: { value: "#00aaff" },
            opacity: { value: 0.3 },
            size: { value: 2 },
            move: { enable: true, speed: 0.6 },
            shape: { type: "circle" },
          },
        }}
      />
      <motion.div
        className="cta"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2>{t("CTA.Title")}</h2>
        <p>{t("CTA.Description")}</p>
        <a href="/contact" className="cta-button">
          {t("CTA.Button")}
        </a>
      </motion.div>
    </section>
  );
};

export default CTA;